import { ref, watch, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useMediaQuery, onKeyStroke } from '@vueuse/core';
const isOpen = ref(false);
/** Test-only helper to reset the module-level singleton between test cases. */
export function resetSidebarDrawer() {
    isOpen.value = false;
}
/**
 * Drawer state for the mobile sidebar. Shared module-level ref — the layout
 * mounts one instance, but any future component can read isOpen without
 * desynchronization. Closes automatically on:
 *   - route change
 *   - viewport crossing the 1024px breakpoint upward
 *   - Esc keypress
 */
export function useSidebarDrawer() {
    const route = useRoute();
    const isDesktop = useMediaQuery('(min-width: 1024px)');
    const stopRoute = watch(() => route.fullPath, () => {
        isOpen.value = false;
    });
    const stopMedia = watch(() => isDesktop.value, (desktop) => {
        if (desktop)
            isOpen.value = false;
    });
    onKeyStroke('Escape', () => {
        if (isOpen.value)
            isOpen.value = false;
    });
    onUnmounted(() => {
        stopRoute();
        stopMedia();
    });
    return {
        isOpen,
        open: () => { isOpen.value = true; },
        close: () => { isOpen.value = false; },
        toggle: () => { isOpen.value = !isOpen.value; },
    };
}
